// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_input {
    display: inline-block;
    position: relative;
    color: var(--color-text);
    cursor: pointer;
    user-select: none;
    flex: 1;
    min-width: 0;
}

.select_input .context_menu {
    position: absolute;
    top: 29px;
    left: 0;
    width: 100%;
}

.select_input .context_menu__popup {
    width: 100%;
}

.select_input_wrapper {
    width: 100%;
    padding-right: 22px;
    height: 29px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid var(--color-border);
}

.select_input__value {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text);
    flex: 1;
    min-width: 0;
}

.select_input__value--placeholder {
    color: var(--color-text-muted);
    font-style: italic;
}

.select_input__arrow {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid var(--color-text-muted);
    flex-shrink: 0;
}

.select_input.expanded .select_input__arrow {
    border-top: none;
    border-bottom: 6px solid var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/SelectInput/s.select_input.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gDAAgD;AACpD","sourcesContent":[".select_input {\n    display: inline-block;\n    position: relative;\n    color: var(--color-text);\n    cursor: pointer;\n    user-select: none;\n    flex: 1;\n    min-width: 0;\n}\n\n.select_input .context_menu {\n    position: absolute;\n    top: 29px;\n    left: 0;\n    width: 100%;\n}\n\n.select_input .context_menu__popup {\n    width: 100%;\n}\n\n.select_input_wrapper {\n    width: 100%;\n    padding-right: 22px;\n    height: 29px;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    border: 1px solid var(--color-border);\n}\n\n.select_input__value {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--color-text);\n    flex: 1;\n    min-width: 0;\n}\n\n.select_input__value--placeholder {\n    color: var(--color-text-muted);\n    font-style: italic;\n}\n\n.select_input__arrow {\n    position: absolute;\n    right: 7px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 0;\n    height: 0;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 6px solid var(--color-text-muted);\n    flex-shrink: 0;\n}\n\n.select_input.expanded .select_input__arrow {\n    border-top: none;\n    border-bottom: 6px solid var(--color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
